export const collection = 'cms_carcase_category';
